import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import router from './routes/router';
import { LinearProgress, Typography } from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';

const PageLoader = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      gap: '1rem',
    }}
  >
    <Typography variant="h5" color="text.secondary">
      ACP
    </Typography>
    <LinearProgress sx={{ width: 280 }} />
  </div>
);

function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}

export default App;
